import { render, staticRenderFns } from "./InjectionHeaderComponent.vue?vue&type=template&id=5556f18e&scoped=true&"
import script from "./InjectionHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./InjectionHeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./InjectionHeaderComponent.vue?vue&type=style&index=0&id=5556f18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556f18e",
  null
  
)

export default component.exports